/* eslint-disable react-hooks/exhaustive-deps */
import React, { CSSProperties, RefObject, useEffect } from "react";
import { cn } from "../utils/cn";

interface ModalContainerProps {
  modalRef?: RefObject<HTMLDivElement>;
  divRef?: RefObject<HTMLDivElement>;
  setIsModalOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  left?: string;
  top?: string;
  bottom?: string;
  right?: string;
  width?: string;
  height?: string;
  maxHeight?: string;
  minHeight?: string;
  className?: string;
  children: React.ReactNode;
}

const ModalContainer: React.FC<ModalContainerProps> = ({
  modalRef,
  divRef,
  setIsModalOpen,
  left,
  top,
  bottom,
  right,
  width,
  height,
  maxHeight,
  minHeight,
  className,
  children,
}) => {
  const handleClickOutside = (event: MouseEvent) => {
    if (modalRef && divRef && setIsModalOpen) {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node) &&
        divRef.current &&
        !divRef.current.contains(event.target as Node)
      ) {
          setIsModalOpen(false);
      }
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
        document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const style: CSSProperties = {
    left,
    top,
    bottom,
    right,
    width,
    height,
    maxHeight,
    minHeight,
    position: "absolute",
  };

  return (
    <div
      ref={modalRef}
      style={style}
      className={cn(["bg-white rounded-xl z-[999] overflow-x-hidden duration-75 animate-zoomIn overflow-y-auto no-scrollbar", className])}
      onClick={e => e.stopPropagation()}
    >
      {children}
    </div>
  );
};

export default ModalContainer;
